import { useNavigate } from "react-router-dom";
import { Radio } from "antd";
import styled from "styled-components";

import logo from "../logo.png";
import Box from "./Box";

const { Group } = Radio;

const StyledGroup = styled(Group)`
  .ant-radio-button-wrapper {
    border-radius: 0;
    &:hover {
      color: #fff;
      background-color: rgb(249 115 25);
      border-color: rgb(249 115 25);
    }
    &:focus-within {
      color: #fff;
      background-color: rgb(249 115 25);
      border-color: rgb(249 115 25);
    }
    &:focus {
      color: #fff;
      background-color: rgb(249 115 25);
      border-color: rgb(249 115 25);
    }
    &:active {
      color: #fff;
      background-color: rgb(249 115 25);
      border-color: rgb(249 115 25);
    }
    &.ant-radio-button-wrapper-checked {
      color: #fff;
      background-color: rgb(249 115 25);
      border-color: rgb(249 115 25);
    }
    &.ant-radio-button-wrapper-checked:hover {
      color: #fff;
      background-color: rgb(249 115 25);
      border-color: rgb(249 115 25);
    }
    &.ant-radio-button-wrapper-checked:focus-within {
      color: #fff;
      background-color: rgb(249 115 25);
      border-color: rgb(249 115 25);
    }
    &.ant-radio-button-wrapper-checked:focus {
      color: #fff;
      background-color: rgb(249 115 25);
      border-color: rgb(249 115 25);
    }
    &.ant-radio-button-wrapper-checked:active {
      color: #fff;
      background-color: rgb(249 115 25);
      border-color: rgb(249 115 25);
    }
    &.ant-radio-button-wrapper-checked::before {
      background-color: #fff;
    }
  }
`;

function Header() {
  const navigate = useNavigate();

  // Options
  const tabOptions = [
    {
      label: "Validators",
      value: "validators",
    },
    {
      label: "Blocks",
      value: "blocks",
    },
    {
      label: "Transactions",
      value: "transactions",
    },
  ];

  const onChange = (e) => {
    if (e.target.value === "validators") {
      navigate("/");
      return;
    }

    navigate(`/${e.target.value}`);
  };

  const getTabActive = () => {
    const path = window.location.pathname;
    const tabActive = tabOptions.find((option) => path.includes(option.value));
    return tabActive ? tabActive.value : "validators";
  };

  return (
    <Box
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <StyledGroup value={getTabActive()} onChange={onChange}>
        {tabOptions.map((option) => (
          <Radio.Button key={option.label} value={option.value}>
            {option.label}
          </Radio.Button>
        ))}
      </StyledGroup>
    </Box>
  );
}

export default Header;
